import type { ReactNode } from "react";

export function PageTitle({
  phaseNum,
  phaseLabel,
  title,
  meta,
  actions,
}: {
  phaseNum?: number;
  phaseLabel?: string;
  title: string;
  meta?: string;
  actions?: ReactNode;
}) {
  const showPhase = phaseNum != null && phaseLabel != null;

  return (
    <section className="px-6 py-4 border-b border-outline-variant bg-surface-container-lowest shrink-0">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          {showPhase ? (
            <>
              <p className="font-data-label text-data-label uppercase text-on-surface-variant">
                Pipeline · Phase {phaseNum}
              </p>
              <p className="text-[10px] uppercase tracking-widest text-on-surface-variant mt-0.5">
                {phaseLabel}
              </p>
            </>
          ) : null}
          <h2 className="font-headline-md text-headline-md text-on-surface mt-1">{title}</h2>
          {meta ? (
            <p className="text-body-sm text-on-surface-variant mt-1">{meta}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex flex-wrap items-center gap-3 shrink-0">{actions}</div>
        ) : null}
      </div>
    </section>
  );
}
